import { ColDef } from 'ag-grid-community';
import React from 'react';
import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { InvoiceShipment, InvoiceStorageTableRow } from '../../models/InvoicesView';

interface InvoicesViewAgGridTableProps {
  rows: InvoiceShipment[] | InvoiceStorageTableRow[];
  isLoading?: boolean;
  isFetching?: boolean;
  className?: string;
  selectedColumns?: string[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  isStorageType?: boolean;
}

export const InvoicesViewAgGridTable = React.memo(function InvoicesViewAgGridTable({
  rows,
  isFetching = false,
  selectedColumns = [],
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  isStorageType = false,
}: InvoicesViewAgGridTableProps) {
  const { filteredColumnDefs } = useAgGridColumns({
    selectedColumns,
    isStorageType,
  });

  return (
    <div
      className={`w-full flex flex-col flex-1 min-h-0 ${
        isFetching && !isFetchingNextPage ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      <div className="flex-1 min-h-0 flex flex-col">
        <AgGridTable
          data={rows}
          columnDefs={filteredColumnDefs as ColDef[]}
          height="100%"
          enableSelection={false}
          onGridReady={() => undefined}
          className="rounded-lg shadow-sm min-h-0 flex-1"
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          gridOptions={{}}
          sorting={sorting}
          onSortingChange={onSortingChange}
          rowHeight={50}
        />
      </div>
    </div>
  );
});
